/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

export const checkDates = (date: string) => {
  if (!date) {
    return null;
  }

  return date === "Invalid Date" || date.length === 0 ? null : date;
};

export const isValidDate = (date: string | null): boolean => {
  if (date === null || date === "") return true;

  const pattern = /^\d{4}-\d{2}-\d{2}$/;
  if (!pattern.test(date)) return false;

  const [y, m, d] = date.split("-").map(Number);
  const dt = new Date(date);

  return (
    dt.getFullYear() === y && dt.getMonth() + 1 === m && dt.getDate() === d
  );
};
